import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { skills } from '../data/skills';

const Skills: React.FC = () => {
  const { t } = useLanguage();
  const categories = ['backend', 'frontend', 'cloud', 'database', 'devops'] as const;

  return (
    <section id="skills" className="py-20 px-6 bg-dark-surface">
      <div className="container mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl font-bold mb-4">
            <span className="text-gradient">{t('skills.title')}</span>
          </h2>
          <p className="text-gray-400">{t('skills.subtitle')}</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
          {categories.map((category) => {
            const categorySkills = skills.filter(skill => skill.category === category);
            return (
              <motion.div
                key={category}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className="bg-dark-card rounded-lg p-6 shadow-xl"
              >
                <h3 className="text-xl font-semibold mb-4 text-white">
                  {t(`skills.${category}`)}
                </h3>
                <div className="space-y-4">
                  {categorySkills.map((skill, index) => {
                    const Icon = skill.icon;
                    return (
                      <motion.div
                        key={skill.name}
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: index * 0.1, duration: 0.4 }}
                        className="flex items-center space-x-3 group"
                      >
                        <Icon className="text-2xl text-blue-400 group-hover:scale-110 transition-transform" />
                        <span className="text-gray-300 group-hover:text-white transition-colors">
                          {skill.name}
                        </span>
                      </motion.div>
                    );
                  })}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Skills;
